
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hzK4Z", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf; }, function (v) { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ccb972f8f1c5733b$export$f7ad0328861e2f03; }, function (v) { return $ccb972f8f1c5733b$export$f7ad0328861e2f03 = v; });
var $ccb972f8f1c5733b$export$6503ec6e8aabbaf;
var $ccb972f8f1c5733b$export$f7ad0328861e2f03;
"use strict";
var $ccb972f8f1c5733b$var$mapping = new Map();
function $ccb972f8f1c5733b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ccb972f8f1c5733b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ccb972f8f1c5733b$var$resolve(id) {
    var resolved = $ccb972f8f1c5733b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ccb972f8f1c5733b$export$6503ec6e8aabbaf = $ccb972f8f1c5733b$var$register;
$ccb972f8f1c5733b$export$f7ad0328861e2f03 = $ccb972f8f1c5733b$var$resolve;

});

parcelRegister("4m9Pp", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $32c0d72e2f6110e1$export$bdfd709ae4826697; }, function (v) { return $32c0d72e2f6110e1$export$bdfd709ae4826697 = v; });
var $32c0d72e2f6110e1$export$bdfd709ae4826697;
var $32c0d72e2f6110e1$export$c9e73fbda7da57b6;
var $32c0d72e2f6110e1$export$5a759dc7a1cfb72a;
"use strict";
var $32c0d72e2f6110e1$var$bundleURL = {};
function $32c0d72e2f6110e1$var$getBundleURLCached(id) {
    var value = $32c0d72e2f6110e1$var$bundleURL[id];
    if (!value) {
        value = $32c0d72e2f6110e1$var$getBundleURL();
        $32c0d72e2f6110e1$var$bundleURL[id] = value;
    }
    return value;
}
function $32c0d72e2f6110e1$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $32c0d72e2f6110e1$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $32c0d72e2f6110e1$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $32c0d72e2f6110e1$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$32c0d72e2f6110e1$export$bdfd709ae4826697 = $32c0d72e2f6110e1$var$getBundleURLCached;
$32c0d72e2f6110e1$export$c9e73fbda7da57b6 = $32c0d72e2f6110e1$var$getBaseURL;
$32c0d72e2f6110e1$export$5a759dc7a1cfb72a = $32c0d72e2f6110e1$var$getOrigin;

});

var $579a321adfaded8e$exports = {};


(parcelRequire("hzK4Z")).register((parcelRequire("4m9Pp")).getBundleURL("bt0xl"), JSON.parse('["bt0xl","confirmation-page.8e2de1fc.js","639I8","sign-up-layout-container.0fdb65c1.js","jbOH1","google-logo.5867462c.svg","6eYXx","microsoft-logo.c73d8dca.svg","2waUd","language-selector.5e567f80.js","fr48Q","dropdown-import.65eae266.js","8KBcn","direct-buy-org-setup-container.c565a1e4.js","210jy","sign-up-layout-container.7c0f2749.js","jc5H5","sign-up-layout-container.5979af9e.js"]'));


//# sourceMappingURL=confirmation-page.runtime.e2d9c53c.js.map
